<template>
  <div
    v-show="visible"
    class="rt-overlay"
    :style="{
      background: overlayBackground,
      'z-index': zIndex,
      display: center ? 'flex' : 'block'
    }"
  >
    <div
      class="rt-overlay-back"
      @click="onClose"
    ></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'RtOverlay',
  props: {
    visible: Boolean,
    center: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: String,
      default: '0.3'
    },
    zIndex: {
      type: String,
      default: '998'
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    overlayBackground () {
      return `rgba(0,0,0,${this.opacity})`;
    }
  },
  methods: {
    onClose () {
      if (this.closeOnClick) {
        this.$emit('update:visible', false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtOverlay.vue?275bff8d